import { useState, useRef, Dispatch, SetStateAction } from 'react';
import ReactCrop, { Crop } from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import Button from '../../components/Button';
import styles from './style.module.scss';
import { useDispatch } from '../../store/store';
import { setCompanyLogoModal, setCroppedCompanyLogo } from '../../store/workspace/slice';

interface Props {
    imageSrc: string | null;
    croppedImage: string | null;
    setCroppedImage: Dispatch<SetStateAction<string | null>>;
};

const ImageCrop: React.FC<Props> = (props) => {
    const dispatch = useDispatch();
    const { imageSrc, setCroppedImage, croppedImage } = props;
    const imageRef = useRef<HTMLImageElement | null>(null);

    const [crop, setCrop] = useState<Crop>({
        unit: 'px',
        x: 175,
        y: 45,
        width: 200,
        height: 200
    });

    const getCroppedImage = () => {
        if (!imageRef.current) return;

        const canvas = document.createElement('canvas');
        const scaleX = imageRef.current.naturalWidth / imageRef.current.width;
        const scaleY = imageRef.current.naturalHeight / imageRef.current.height;
        const ctx = canvas.getContext('2d');

        const pixelCrop = {
            x: (crop.x! * scaleX),
            y: (crop.y! * scaleY),
            width: (crop.width! * scaleX),
            height: (crop.height! * scaleY),
        };

        canvas.width = pixelCrop.width;
        canvas.height = pixelCrop.height;

        if (ctx) {
            ctx.drawImage(
                imageRef.current,
                pixelCrop.x,
                pixelCrop.y,
                pixelCrop.width,
                pixelCrop.height,
                0,
                0,
                pixelCrop.width,
                pixelCrop.height,
            );

            canvas.toBlob((blob) => {
                if (blob) {
                    const croppedUrl = URL.createObjectURL(blob);
                    setCroppedImage(croppedUrl); // Set the cropped image URL without preview
                    dispatch(setCroppedCompanyLogo(croppedUrl));
                    dispatch(setCompanyLogoModal(false));
                }
            });
        }
    };

    const onSave = () => {
        dispatch(setCroppedCompanyLogo(croppedImage));
        dispatch(setCompanyLogoModal(false));
    };

    return (
        <div className={styles.wrapper}>
            {imageSrc && (
                <>
                    <ReactCrop
                        crop={crop}
                        aspect={1}
                        keepSelection
                        onChange={(newCrop) => setCrop(newCrop)}
                    >
                        <img
                            ref={imageRef}
                            alt="Crop"
                            src={imageSrc}
                        />
                    </ReactCrop>
                </>
            )}
            <div className={styles.actions}>
                <Button
                    type='Outline-Primary'
                    text='Cancel'
                    className={styles.actions_btn}
                    onClick={() => dispatch(setCompanyLogoModal(false))}
                />
                <Button
                    type='Primary'
                    text='Confirm'
                    onClick={getCroppedImage}
                    className={styles.actions_btn}
                />
            </div>
        </div>
    );
};

export default ImageCrop;